import { TENANT } from '@/page/config/base_config'
import api from '../api'

const currentTenant = {
  data() {
    return {
      currentTenant: {},
      orgList: []
    }
  },
  mounted() {
    if (TENANT.isShow) {
      this.getCurrentTenant()
    } else {
      this.currentTenant = {
        name: TENANT.name
      }
    }
  },
  methods: {
    async getCurrentTenant() {
      if (this.orgList.length) {
        return false
      }
      try {
        const { code, data } = await api.apiTenantListAvailable()
        if (code !== 200) {
          return false
        }
        const currentUser = this.$store.state.user
        if (data && currentUser) {
          const {
            tenantId,
            subject
          } = currentUser.userInfo
          this.currentTenant = data.filter(item => item.id === tenantId)[0]
          if (subject && subject.orgList) {
            this.orgList = subject.orgList
          }
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    }
  }
}

export default currentTenant
